"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("objectUtils", function () {
  // TODO : tests
  return {
    /**
     * Remove all entry from given object.
     * This will only remove own properties from the object (testing hasOwnProperty)
     *
     * @param obj The object to remove all entries from.
     */
    clearObject: function clearObject(obj) {
      var keys = _.keys(obj);
      _.each(keys, function (key) {
        delete obj[key];
      });
    },
    /**
     * Returns true if object has at least one not null own property, false otherwise.
     * @param obj The object to check to non-null properties
     * @param {Array<String>=} keys Optional keys subset to use instead of obj.keys()
     */
    containsNotNullProperties: function containsNotNullProperties(obj, keys) {
      var keys = keys || _.keys(obj);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (obj.hasOwnProperty(key) && obj[key] != null) {
          return true;
        }
      }
      return false;
    },
    getProperty: function getProperty(obj, prop) {
      // TODO: replace whole implem with _.get
      var parts = prop.split('.');
      if (parts.length === 1) {
        return obj[prop];
      }
      var last = parts.pop(),
        l = parts.length,
        i = 1,
        current = parts[0];
      while ((obj = obj[current]) && i < l) {
        current = parts[i];
        i++;
      }
      if (obj) {
        return obj[last];
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/objectUtils.js
// module id = 2760
// module chunks = 13